
import * as z from "zod";

export const onboardingFormSchema = z.object({
  creator_name: z.string().min(1, { message: "Creator name is required" }),
  social_media_type: z.string().min(1, { message: "Social media type is required" }),
  social_media_handler: z.string().min(1, { message: "Social media handle is required" }),
  social_media_name: z.string().min(1, { message: "Social media name is required" }),
  agreed_rate: z.number().min(0.01, { message: "Agreed rate must be greater than 0" }),
  currency_type: z.string().min(1, { message: "Currency type is required" }),
  region: z.string().min(1, { message: "Region is required" }),
  start_date: z.date({ required_error: "Start date is required" }),
  end_date: z.date().optional(),
  content_links: z.array(z.string()).optional().default([]),
  compensation_amount: z.number().optional(),
  compensation_currency: z.string().optional(),
  experience_rate: z.number().min(0).max(5).optional(),
  invoice_link: z.string().optional(),
  pic_id: z.string().min(1, { message: "Contact person name is required" }),
  pic: z.array(z.string()).optional().default([]),
  collaboration_period: z.string().optional(),
  email: z.string().email({ message: "Please enter a valid email address" }).optional(),
  feedback: z.string().optional(),
  deliverables: z.string().optional(),
  // Invoice fields
  invoice_number: z.string().optional(),
  invoice_date: z.date().optional(),
  wallet_address: z.string().optional(),
  wallet_address_network: z.string().optional(),
  chain: z.enum(["L1", "L2"]).optional(),
  amount: z.number().optional(),
  total: z.number().optional(),
  description: z.string().optional(),
  document_url: z.string().optional(),
  // Test transaction fields
  test_transfer: z.boolean().optional().default(false),
  test_transfer_url: z.string().optional(),
  test_transfer_confirmed: z.boolean().optional().default(false),
});

export type OnboardingFormValues = z.infer<typeof onboardingFormSchema>;
